import { PhoneNumber } from 'lib-shared-legacy-types';

import {
  TopBarButtonDispatchPropsT,
  TopBarButtonStatePropsT,
} from '../containers/topbarButtons';

import { PhoneNumberSelect } from './PhoneNumberSelect';
import { PowerCallFlowExtraDataT } from './PowerCallFlow';

type TopBarButtonsOwnPropsT = {
  changeNumber: (number: PhoneNumber) => void;
  extraData: PowerCallFlowExtraDataT;
  isFlowActive: boolean;
};

export type PropsT = TopBarButtonsOwnPropsT &
  TopBarButtonStatePropsT &
  TopBarButtonDispatchPropsT;

export const TopbarButtons = ({
  extraData,
  isFlowActive,
  changeNumber,
  getNumbersByQuery,
}: PropsT): JSX.Element => {
  return (
    <PhoneNumberSelect
      changePhoneNumber={changeNumber}
      className="flow-number-selector"
      disabled={isFlowActive}
      getPhoneNumbersByQuery={getNumbersByQuery}
      phoneNumber={extraData.number}
    />
  );
};
